import { gql } from '@apollo/client';

export const GET_CAMPAIGN_DETAILS = gql`
  query GetCampaign($id: ID!) {
    campaign(id: $id) {
      id
      name
      kind
      kindLabel
      discountPercentage
      campaignMessagesCount
      createdAt
      onlyVerifiedWhatsappCampaigns
      images {
        id
        url
      }
      group {
        id
        name
      }
      campaignMode
      selectedProducts {
        id
        name
        price
      }
    }
  }
`;

export const GET_CAMPAIGN_MESSAGES = gql`
  query GetCampaignMessages($campaignId: ID!, $page: Int!, $perPage: Int!, $status: String, $search: String) {
    campaignMessages(campaignId: $campaignId, page: $page, perPage: $perPage, status: $status, search: $search) {
      totalCount
      edges {
        node {
          id
          message
          status
          statusLabel
          scheduledFor
          errorMessage
          favoriteProduct
          createdAt
          customer {
            id
            name
            document
            whatsapp
          }
        }
      }
    }
  }
`;


// New queries for products and customers
export const GET_PRODUCTS = gql`
  query GetProducts {
    products {
      edges {
        node {
          id
          name
          price
          active
        }
      }
    }
  }
`;

export const GET_CUSTOMERS = gql`
  query GetCustomers {
    customers {
      edges {
        node {
          id
          name
          document
          whatsapp
        }
      }
    }
  }
`;

// Query específica para busca de clientes usando o searchCustomers resolver
export const SEARCH_CUSTOMERS_CAMPAIGN = gql`
  query SearchCustomers($query: String!) {
    searchCustomers(query: $query) {
      id
      name
      document
      whatsapp
    }
  }
`;